import styled from 'styled-components';

// Styled component definition
const InputField = styled.input`
  width: 90%;
  margin: 2rem 2.5%;
  height: 3rem;
  padding: 0 1rem;
  outline: none;
  border: rgba(138, 94, 191, 1) solid 1.5px;
  border-radius: 7.5px;
  color: rgba(138, 94, 191, 1);
  font-weight: 700;
`;

export default InputField;